import { render, staticRenderFns } from "./CinemaAdd.vue?vue&type=template&id=9b34472c&scoped=true&"
import script from "./CinemaAdd.vue?vue&type=script&lang=js&"
export * from "./CinemaAdd.vue?vue&type=script&lang=js&"
import style0 from "./CinemaAdd.vue?vue&type=style&index=0&id=9b34472c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b34472c",
  null
  
)

export default component.exports